import { Common } from '../../common';
import {
  Question,
  UpdateValues,
} from '../../models/patient/order/clinicalQuestion';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(orderId: string, options: { q?: string }): Promise<Question[]> {
    const url = this.common.constructPath(
      `/patient-orders/${orderId}/clinical-questions`,
      options,
    );
    return this.common.getJSON(url);
  }

  async create(args: { orderId: string; question: string }): Promise<Question> {
    const { orderId, question } = args;
    const url = this.common.constructPath(
      `/patient-orders/${orderId}/clinical-questions`,
    );
    return this.common.postJSON(url, { question });
  }

  async update(args: {
    orderId: string;
    questionId: string;
    values: UpdateValues;
  }) {
    const { orderId, questionId, values } = args;
    const url = this.common.constructPath(
      `/patient-orders/${orderId}/clinical-questions/${questionId}`,
    );
    return this.common.patchJSON(url, values);
  }
}
